import React from "react";
import Resources from "../../../types/Resources";
import TextArea from "../../Common/TextArea";
import FormElement from "../../../types/forms/FormElement";
import Button from "../../Common/Button";

type AdminCommentProps = {
    show: boolean;
    formElement: FormElement<string>;
    onChange: (value: string) => void;
    readonly: boolean;
    showUpdateButton: boolean;
    onUpdateButtonClick: () => void;
    resources: Resources;
    containerClassName?: string;
};

function AdminComment({
    show,
    formElement,
    onChange,
    readonly,
    showUpdateButton,
    onUpdateButtonClick,
    resources,
    containerClassName = ""
}: AdminCommentProps) {
    return show ? (
        <div className={containerClassName}>
            {showUpdateButton ? <Button onClick={onUpdateButtonClick}>{resources.get("UpdateComment")}</Button> : null}
            <TextArea
                value={formElement.value}
                errorMessage={formElement.errorMessage ?? ""}
                labelText={resources.get("AdminComment") ?? ""}
                onChange={onChange}
                textAreaId="admin-comment"
                readOnly={readonly}
            />
        </div>
    ) : null;
}

export default AdminComment;
